<div class="quickview-wrapper calendar-event open" style="padding: 1rem;">
  <div class="card" style="height: 100%;">
    <div class="card-block" [ngStyle]="{'height': innerHeight + 'px', 'overflow-y': 'auto', 'overflow-x': 'hidden'}">
      <form #form="ngForm" [formGroup]="smartForm">
        <div class="form-group row" style="margin-left: 5px;margin-top: 5px;">
          <div class="col-sm-6 col-md-6 col-lg-6">
            <div class="btn-group">

              <button type="button" class="btn btn-default btn-sm dropdown-toggle" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                @if (activity.workingState === 0) {
                <i class="fa fa-circle text-danger" aria-hidden="true"></i>
                }
                @if (activity.workingState === 1) {
                <i class="fa fa-circle text-warning" aria-hidden="true"></i>
                }
                @if (activity.workingState === 2) {
                <i class="fa fa-circle text-success" aria-hidden="true"></i>
                }
              </button>

              <div class="dropdown-menu">
                <a class="dropdown-item" href="javascript:void(0)" (click)="setWorkingState(0)">
                  @if (activity.workingState !== 0) {
                  <i class="fa fa-circle text-danger" aria-hidden="true"></i>
                  }
                </a>
                <a class="dropdown-item" href="javascript:void(0)" (click)="setWorkingState(1)">
                  @if (activity.workingState !== 1) {
                  <i class="fa fa-circle text-warning" aria-hidden="true"></i>
                  }
                </a>
                <a class="dropdown-item" href="javascript:void(0)" (click)="setWorkingState(2)">
                  @if (activity.workingState !== 2) {
                  <i class="fa fa-circle text-success" aria-hidden="true"></i>
                  }
                </a>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6">
            <div class="btn-group">
              <button type="button" class="btn btn-default btn-sm dropdown-toggle" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false" pTooltip="{{ 'activity-editor.priority' | translate }}">
                @if (activity.priority === 0) {
                <i class="fa fa-exclamation text-danger" aria-hidden="true"></i>
                }
                @if (activity.priority === 0) {
                <i class="fa fa-exclamation text-danger" aria-hidden="true"></i>
                }
                @if (activity.priority === 1) {
                <i class="fa fa-exclamation text-danger" aria-hidden="true"></i>
                }
                @if (activity.priority === 3) {
                <i class="fa fa-exclamation text-success" aria-hidden="true"></i>
                }
                @if (activity.priority === 2) {
                <i aria-hidden="true"></i>
                }
              </button>
              <div class="dropdown-menu">
                @if (activity.priority !== 0) {
                <a class="dropdown-item" href="javascript:void(0)" (click)="setPriorityState(0)">
                  <i class="fa fa-exclamation text-danger" aria-hidden="true"></i>
                  <i class="fa fa-exclamation text-danger" aria-hidden="true"></i>
                  {{ 'activity-priority.immediate' | translate }}
                </a>
                }
                @if (activity.priority !== 1) {
                <a class="dropdown-item" href="javascript:void(0)" (click)="setPriorityState(1)">
                  <i class="fa fa-exclamation text-danger" aria-hidden="true"></i>
                  {{ 'activity-priority.high' | translate }}
                </a>
                }
                @if (activity.priority !== 2) {
                <a class="dropdown-item" href="javascript:void(0)" (click)="setPriorityState(2)">
                  <i aria-hidden="true"></i> {{ 'activity-priority.normal' | translate }}
                </a>
                }
                @if (activity.priority !== 3) {
                <a class="dropdown-item" href="javascript:void(0)" (click)="setPriorityState(3)">
                  <i class="fa fa-exclamation text-success" aria-hidden="true"></i>
                  {{ 'activity-priority.low' | translate }}
                </a>
                }
              </div>
            </div>
          </div>


        </div>

        <hr>

        <!--effective time-->
        <div class="form-group row">
          <label for="inputHours" class="col-form-label col-form-label-sm col-lg-4">{{ 'activity-editor.effectiveTime' |
            translate }}</label>
          <div class="col-lg-8">
            @if (!activityTimeEditor) {
            <input type="number" minlength="0" maxlength="4" id="inputHours" name="inputHours" class="form-control"
              formControlName="effectiveTime" min="0.00" max="99.99" step="0.00" [(ngModel)]="activity.effectiveTime">
            }

            @if (activityTimeEditor) {
            <input type="time" class="form-control" [(ngModel)]="efTime" [ngModelOptions]="{standalone: true}"
              (change)="timeChange()">
            }
          </div>
        </div>

        <!--calendar-->
        <div class="form-group row">

          <label for="calendar" class="col-form-label col-form-label-sm col-lg-4">
            {{ 'activity-editor.calendar' | translate }}
          </label>

          <div class="col-lg-8">
            <div [class]="!smartForm.controls['calendar'].valid ? 'input-group has-warning': 'input-group'">
              <input id="calendar" name="calendar" [disabled]="true" formControlName="calendar"
                [(ngModel)]="activity.calendar.name" [class]="getControlClass('calendar')">
              @if (!searchingCalendar) {
              <a href="javascript:void(0)" (click)="removeCalendar()" class="input-group-addon activity-btn">
                <i class="fa fa-times fa-x4 pull-right" aria-hidden="true"></i>
              </a>
              }
              @if (searchingCalendar) {
              <a href="javascript:void(0)" (click)="previousCalendar()" class="input-group-addon activity-btn">
                <i class="fa fa-minus-square-o" aria-hidden="true"></i>
              </a>
              }
            </div>
            @if (searchingCalendar) {
            <calendar-search (selected)="onSelectCalendar($event)">
            </calendar-search>
            }
          </div>
        </div>

        <!--owner-->
        <div class="form-group row">
          <label for="owner" class="col-form-label col-form-label-sm col-lg-4">{{ 'activity-editor.owner' | translate
            }}</label>
          <div class="col-lg-8">
            <div [class]="!smartForm.controls['ownervalid'].valid ? 'input-group has-warning': 'input-group'">
              <input id="owner" name="owner" [disabled]="true" formControlName="ownervalid"
                [(ngModel)]="activity.ownerFullName" [class]="getControlClass('ownervalid')"
                [title]="!smartForm.controls['ownervalid'].valid ? ('activity-editor.requiredmsg' | translate) : ''">
              @if (!searchingOwners) {
              <a href="javascript:void(0)" (click)="removeOwner()" class="input-group-addon activity-btn">
                <i class="fa fa-times fa-x4 pull-right" aria-hidden="true"></i>
              </a>
              }
              @if (searchingOwners) {
              <a href="javascript:void(0)" (click)="previousOwner()" class="input-group-addon activity-btn">
                <i class="fa fa-minus-square-o" aria-hidden="true"></i>
              </a>
              }
            </div>
            @if (!this.activity.ownerFullName) {
            <calendar-search-owner (selected)="onSelectOwner($event)" [calendar]="activity.calendar.id">
            </calendar-search-owner>
            }
          </div>
        </div>

        <!--typology-->
        <div class="form-group row">
          <label for="typology" class="col-form-label col-form-label-sm col-lg-4">{{ 'activity-editor.typology' |
            translate }}</label>
          <div class="col-lg-8">
            <div [class]="!smartForm.controls['typologyvalid'].valid ? 'input-group has-warning': 'input-group'">
              <input id="typology" name="typology" [disabled]="true" formControlName="typologyvalid"
                [ngModel]="activity.activityTypology.name" [class]="getControlClass('typologyvalid')"
                [title]="!smartForm.controls['typologyvalid'].valid ? ('activity-editor.requiredmsg' | translate) : ''">
              @if (activity.activityTypology.name) {
              <a href="javascript:void(0)" (click)="removeTypology()" class="input-group-addon activity-btn">
                <i class="fa fa-times fa-x4 pull-right" aria-hidden="true"></i>
              </a>
              }
              @if (!activity.activityTypology.name) {
              <a href="javascript:void(0)" (click)="previousTypology()" class="input-group-addon activity-btn">
                <i class="fa fa-minus-square-o" aria-hidden="true"></i>
              </a>
              }
            </div>

            @if (!activity.activityTypology.name) {
            <calendar-search-typology (selected)="onSelectTypology($event)">
            </calendar-search-typology>
            }
          </div>
        </div>

        <!--subject-->
        <div class="form-group">
          <label for="subject" class="col-form-label col-form-label-sm">{{ 'activity-editor.subject' | translate
            }}</label>

          <div [class]="!smartForm.controls['activitysubject'].valid ? 'has-warning': ''">
            <textarea set-focus rows="5" cols="4" id="subject" name="subject" [(ngModel)]="activity.subject"
              formControlName="activitysubject" [class]="getControlClass('activitysubject')"
              [title]="!smartForm.controls['activitysubject'].valid ? ('activity-editor.requiredmsg' | translate) : ''">
                    </textarea>

          </div>
        </div>

        <hr>

        <!--parties-->
        <div class="form-group">

          <label for="parties" class="col-form-label col-form-label-sm">
            {{ 'activity-editor.parties' | translate }}
          </label>
          <a class="pull-right activity-btn" (click)="addParty()" href="javascript:void(0)">
            @if (!searchingParties) {
            <i class="fa fa-plus-square-o fa-lg"></i>
            }
            @if (searchingParties) {
            <i class="fa fa-minus-square-o fa-lgx4"></i>
            }
          </a>

          @if (searchingParties) {
          <search [hideDetails]="true" [hideSettings]="true" (select)="onSelectParty($event)">
          </search>
          }

          @if (hasParties()) {
          <div id="parties" style="max-height: 130px;overflow:auto;">
            @for (p of activity.parties; track $index) {
            <div class="input-group">
              <input disabled="disabled" class="form-control input-smart" [ngModel]="p.partyName"
                [ngModelOptions]="{standalone: true}">
              <a href="javascript:void(0)" class="input-group-addon" style="padding: .3em 0.5em;"
                (click)="crmLink(p.idParty)">
                <i class="fa fa-address-card-o text-danger" aria-hidden="true"></i>
              </a>
              <a href="javascript:void(0)" class="input-group-addon activity-btn input-smart" (click)="removeParty(p)">
                <i class="fa fa-times fa-x4 pull-right" aria-hidden="true"></i>
              </a>
              <a href="javascript:void(0)" class="input-group-addon activity-btn input-smart"
                (click)="addRelatedParty(p)">
                @if (p !== currentSubject) {
                <i class="fa fa-plus" aria-hidden="true"></i>
                }
                @if (p === currentSubject) {
                <i class="fa fa-minus" aria-hidden="true"></i>
                }
              </a>
            </div>
            <div style="margin-left: 0.5rem;">
              @if (p === currentSubject) {
              <search [hideDetails]="true" [hideSettings]="true" [smallMode]="true" [subjectId]="p.idParty"
                (select)="onSelectParty($event)">
              </search>
              }
            </div>
            }
          </div>
          }
        </div>

        <!--date-->
        <div class="ui-g ui-fluid">
          <div class="ui-g-12">
            <label for="dateControl" class="col-form-label col-form-label-sm">{{ 'activity-editor.date' | translate
              }}</label>
            <p-calendar styleClass="am-pCalendar" class="lf-calendar" id="dateControl" dataType="date"
              dateFormat="dd-mm-yy" yearRange="2016:2050" [locale]="locale" appendTo="body" [showIcon]="true"
              [yearNavigator]="true" [monthNavigator]="true" [(ngModel)]="_date" [selectOtherMonths]="true"
              [ngModelOptions]="{standalone: true}" [required]="true">
            </p-calendar>
          </div>
        </div>

        <div class="ui-g ui-fluid">
          <div class="ui-g-12">
            <label for="expiryDate" style="width: 100%;" class="col-form-label col-form-label-sm">
              {{ 'activity-editor.expiryDate' | translate }}
            </label>
            <p-calendar styleClass="am-pCalendar" class="lf-calendar" id="dateControl" dataType="date"
              dateFormat="dd-mm-yy" yearRange="2016:2050" [locale]="locale" appendTo="body" [showIcon]="true"
              [yearNavigator]="true" [monthNavigator]="true" [(ngModel)]="_expireDate" [selectOtherMonths]="true"
              [ngModelOptions]="{standalone: true}" [required]="true">
            </p-calendar>
          </div>
        </div>
      </form>

    </div>
    <div class="card-footer">
      <button type="button" class="activity btn btn-primary btn-block" [disabled]="!smartForm.valid" (click)="save(1)">
        {{ 'app.save-close' | translate }}
      </button>
      <button type="button" class="activity btn btn-primary btn-block" [disabled]="!smartForm.valid" (click)="save(2)">
        {{ 'app.save-new' | translate }}
      </button>
      <button type="button" class="activity btn btn-primary btn-block" [disabled]="!smartForm.valid" (click)="save(3)">
        {{ 'app.save-open' | translate }}
      </button>
      <button type="button" class="btn btn-default btn-block" (click)="close()">
        {{ 'app.close' | translate }}
      </button>
    </div>
  </div>

</div>